'use client'

import { createContext, useContext, ReactNode } from 'react'
import { NotFoundFragment } from '@/components/NotFound/NotFound.generated'

type NotFoundTranslationsContextType = {
	translations: Record<string, NotFoundFragment>
	getTranslation: (locale: string) => NotFoundFragment | null
}

const NotFoundTranslationsContext =
	createContext<NotFoundTranslationsContextType | null>(null)

export function NotFoundTranslationsProvider({
	children,
	translations,
}: {
	children: ReactNode
	translations: Record<string, NotFoundFragment>
}) {
	const getTranslation = (locale: string): NotFoundFragment | null => {
		return translations[locale] || null
	}

	return (
		<NotFoundTranslationsContext.Provider
			value={{ translations, getTranslation }}
		>
			{children}
		</NotFoundTranslationsContext.Provider>
	)
}

export function useNotFoundTranslations() {
	const context = useContext(NotFoundTranslationsContext)
	if (!context) {
		throw new Error(
			'useNotFoundTranslations must be used within a NotFoundTranslationsProvider',
		)
	}
	return context
}
